<template>
  <div>
    <h1>Check My Charter</h1>
    <p><a href="https://renter.loc">Back To renter.loc</a></p>

    <div
      v-if="isTableLoading"
      class="text-center pt-3"
    >
      <b-spinner label="Loading..." />
    </div>

    <template v-else>
      <!-- search input -->
      <div class="custom-search d-flex justify-content-end">
        <b-form-group>
          <div class="d-flex align-items-center">
            <label class="mr-1">Search</label>
            <b-form-input
              v-model="searchTerm"
              placeholder="Search"
              type="text"
              class="d-inline-block"
            />
          </div>
        </b-form-group>
      </div>

      <vue-good-table
        :columns="columns"
        :rows="charters"
        :search-options="{
          enabled: true,
          externalQuery: searchTerm }"
        :pagination-options="{
          enabled: true,
          perPage:pageLength
        }"
      >
        <template
          slot="table-row"
          slot-scope="props"
        >
          <DatatableCellValue
            :field="props.column.field"
            :value="props.formattedRow[props.column.field]"
          />
        </template>

        <!-- pagination -->
        <template #pagination-bottom="props">
          <TablePagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              @input="(value)=>props.pageChanged({currentPage:value})"
              @per-page-change="(n) => { pageLength = n; props.perPageChanged({ currentPerPage: n }) }"
            />
        </template>
      </vue-good-table>
    </template>
  </div>
</template>

<script>
import {
  BPagination,
  BFormGroup,
  BFormInput,
  BSpinner,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table-next'
import { mapActions, mapGetters } from 'vuex'
import TablePagination from '@/views/Components/Elements/TablePagination.vue'
import DatatableCellValue from '@/views/Components/Elements/DatatableCellValue.vue'
import { toastFailure } from '@/libs/toastification'

export default {
  components: {
    TablePagination,
    DatatableCellValue,
    VueGoodTable,
    BPagination,
    BFormGroup,
    BFormInput,
    BSpinner,
  },
  data() {
    return {
      isTableLoading: true,
      searchTerm: '',
      columns: [
        {
          label: 'Date',
          field: 'date',
        },
        {
          label: 'Unit',
          field: 'unit',
        },
        {
          label: 'Name',
          field: 'name',
        },
        {
          label: 'Time',
          field: 'time',
        },
        {
          label: 'Reservation #',
          field: 'id',
          type: 'number',
        },
      ],
      pageLength: 25,
    }
  },
  computed: {
    ...mapGetters({
      charters: 'sales/charters',
    }),
  },
  async mounted() {
    await this.loadCharters()
      .then(() => { this.isTableLoading = false })
      .catch(() => { toastFailure('Something went wrong.') })
  },
  methods: {
    ...mapActions({
      loadCharters: 'sales/loadCharters',
    }),
  },
}
</script>

<style>

</style>
